const functionAppURL = import.meta.env.VITE_FUNCTION_APP_URL;
const subscriptionKey = import.meta.env.VITE_SUBSCRIPTION_KEY;

const MAX_RETRIES = 10;
const BASE_DELAY = 1000;

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const retryWithBackoff = async (operation: Function) => {
  let lastError;

  for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
    try {
      const response = await operation();
      if (response.ok) {
        return response;
      }
      lastError = new Error(`HTTP error! status: ${response.status}`);
    } catch (error) {
      lastError = error;
    }

    if (attempt < MAX_RETRIES - 1) {
      const delay = BASE_DELAY * Math.pow(2, attempt);
      await sleep(delay);
    }
  }
  throw lastError;
};

export const fetchData = async (endpoint: string, bearerToken: string) => {
  try {
    const response = await fetch(`${functionAppURL}${endpoint}`, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Ocp-Apim-Subscription-Key': subscriptionKey,
      },
    });
    if (!response.ok) {
      throw new Error('Error fetching data');
    }
    return response;
  } catch (error) {
    throw error;
  }
};

export const postJson = async (
  endpoint: string,
  json: object,
  bearerToken: string,
) => {
  return await doJsonMethod('POST', endpoint, json, bearerToken);
};

export const postJsonInvoke = async (
  endpoint: string,
  json: object,
  bearerToken: string,
) => {
  return await doJsonMethodInvoke('POST', endpoint, json, bearerToken);
};

const doJsonMethod = async (
  methodType: string,
  endpoint: string,
  json: object,
  bearerToken: string,
) => {
  return retryWithBackoff(async () => {
    const url = `${functionAppURL}${endpoint}`;
    const response = await fetch(url, {
      method: methodType,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${bearerToken}`,
        'Ocp-Apim-Subscription-Key': subscriptionKey,
      },
      body: JSON.stringify(json),
    });
    return response;
  });
};

const doJsonMethodInvoke = async (
  methodType: string,
  endpoint: string,
  json: object,
  bearerToken: string,
) => {
  const url = `${functionAppURL}${endpoint}`;
  try {
    const response = await fetch(url, {
      method: methodType,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${bearerToken}`,
        'Ocp-Apim-Subscription-Key': subscriptionKey,
      },
      body: JSON.stringify(json),
    });
    if (!response.ok) {
      throw new Error(
        `HTTP error! status: ${response.status} - ${response.statusText}`,
      );
    } else {
      return;
    }
  } catch (error) {
    throw error;
  }
};
